(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      
      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
        return;
      }

      // Simple scroll tracking
      this.lastScrollTop = 0;
      this.scrollThreshold = 10; // Minimum scroll distance to trigger show/hide
      this.isScrolling = false;
      this.headerHeight = 0;
      
      this.onScrollHandler = this.onScroll.bind(this);
      
      // Use passive listener for better performance on mobile
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
      
      // Update header height on resize
      window.addEventListener('resize', () => this.setHeaderHeight(), { passive: true });
    }

    setHeaderHeight() {
      if (this.header) {
        this.headerHeight = this.header.offsetHeight;
        document.documentElement.style.setProperty('--header-height', `${this.headerHeight}px`);
      }
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    onScroll() {
      if (this.isScrolling) return;
      
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const scrollDifference = Math.abs(scrollTop - this.lastScrollTop);
      
      // Only process if scroll difference is significant
      if (scrollDifference < this.scrollThreshold) {
        return;
      }

      // Update header height if needed (in case it changed)
      if (!this.headerHeight || this.headerHeight === 0) {
        this.setHeaderHeight();
      }

      this.isScrolling = true;
      requestAnimationFrame(() => {
        // Always show header if we're at the top (within header height)
        if (scrollTop <= this.headerHeight) {
          this.showHeader();
        } else if (scrollTop > this.lastScrollTop) {
          // Scrolling down - hide header (only after passing header height)
          this.hideHeader();
        } else {
          // Scrolling up - show header
          this.showHeader();
        }
        
        this.lastScrollTop = scrollTop;
        this.isScrolling = false;
      });
    }

    hideHeader() {
      this.header.classList.add('shopify-section-header-hidden');
      this.header.classList.add('shopify-section-header-sticky');
      this.closeMenuDisclosure();
    }

    showHeader() {
      this.header.classList.remove('shopify-section-header-hidden');
      this.header.classList.add('shopify-section-header-sticky');
    }

    closeMenuDisclosure() {
      const disclosures = this.header.querySelectorAll('header-menu');
      disclosures.forEach((disclosure) => disclosure.close());
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabs-featured-products"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function() {
      var tabs = document.querySelectorAll('.tfp-tab');
      var tabContents = document.querySelectorAll('.tfp-tab-content');
      var dropdownSelected = document.querySelector('.dropdown-selected');
      var dropdownSelectedIcon = document.querySelector('.dropdown-selected-icon');
      var dropdownSelectedName = document.querySelector('.dropdown-selected-name');
      var dropdownToggle = document.querySelector('.dropdown-toggle');
      var dropdownMenu = document.querySelector('.dropdown-menu');
      var dropdownItems = document.querySelectorAll('.dropdown-item');
    
      function showTab(index) {
        tabs.forEach(function(tab, i) {
          tab.classList.toggle('active', i === index);
        });
        tabContents.forEach(function(content, i) {
          content.style.display = (i === index) ? 'flex' : 'none';
          content.classList.toggle('active', i === index);
        });
        if (dropdownSelected && dropdownItems[index]) {
          var icon = dropdownItems[index].querySelector('img');
          if (dropdownSelectedIcon && icon) {
            dropdownSelectedIcon.src = icon.src;
            dropdownSelectedIcon.alt = icon.alt;
          }
          if (dropdownSelectedName) {
            dropdownSelectedName.textContent = dropdownItems[index].textContent.trim();
          }
        }
      }
    
      tabs.forEach(function(tab, i) {
        tab.addEventListener('click', function() {
          showTab(i);
        });
      });
    
      // Custom dropdown logic
      if (dropdownToggle && dropdownMenu) {
        dropdownToggle.addEventListener('click', function(e) {
          e.stopPropagation();
          dropdownMenu.style.display = dropdownMenu.style.display === 'block' ? 'none' : 'block';
        });
    
        dropdownItems.forEach(function(item, i) {
          item.addEventListener('click', function() {
            showTab(i);
            dropdownMenu.style.display = 'none';
          });
        });
    
        document.addEventListener('click', function() {
          dropdownMenu.style.display = 'none';
        });
      }
    
      // Set initial tab
      showTab(0);
    });
    
  } catch(e) { console.error(e); }
})();
})();
